import "./assets/fonts/fonts.css";
import "./assets/css/reset.scss";
import "./assets/css/public.scss";
// 暗黑模式
import "element-plus/theme-chalk/dark/css-vars.css";
import "./assets/css/dark-var.scss";
import 'element-plus/theme-chalk/index.css';
import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import { pulicEl } from "./utils/directive";

const app = createApp(App);

app.use(createPinia());
app.use(router);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component);
}

app.directive("setPermission", {
	mounted(el, binding, vnode) {
		pulicEl(el, binding, vnode);
	},
	updated(el, binding, vnode) {
		pulicEl(el, binding, vnode);
	},
});

app.mount("#app");
